import axios from 'axios';

import { authHeader } from '@H';

export default {
  getPackages: () =>
    axios({
      method: 'GET',
      headers: authHeader(1),
      url: `${process.env.API_URL}/subscription/subscription-package/`,
    }),
  getAllFeatures: () =>
    axios({
      method: 'GET',
      headers: authHeader(),
      url: `${process.env.API_URL}/subscription/package-features/`,
    }),
  getExistingPlans: () =>
    axios({
      method: 'GET',
      headers: authHeader(1),
      url: `${process.env.API_URL}/subscription/subscription-plan/`,
    }),
  getValidityPeriods: () =>
    axios({
      method: 'GET',
      headers: authHeader(1),
      url: `${process.env.API_URL}/subscription/validity/validity-list/`,
    }),
};
